import apiClient from '@/services/axios'
import { types as MutationTypes } from './mutations'
import qs from 'qs'
import moment from 'moment'


export const GETPRODUCT = async (
  { commit },
  { business_id, channel, channelId, params, signal, isExport },
) => {
  let data = [],
    props = { all: 0, total_row: 0 }

  try {
    commit(MutationTypes.SET_PRODUCT_CHANNEL, {
      loading: true,
    })

    const headers = {
      'Business-Id': business_id,
    }

    const isDistributor = channel === 'distributor'
    const isBlibli = channel.includes('blibli')
    const { data: response } = await apiClient({
      method: 'get',
      url: `/channel/${channel}/product/query/${isDistributor ? 'powerbiz/' : ''}${channelId}`,
      params,
      headers,
      signal,
    })

    const { data: res, ...obj } = response || {}
    obj.all = obj.active + obj.notActive // ???
    if (isDistributor && res?.length && !isExport) {
      await apiClient({
        method: 'get',
        url: `/channel/distributor/price/query/v2/powerbiz/${channelId || ''}`,
        params: {
          product_id: res.map(f => f.id || f.product_id).join(','),
          effective_date: moment().format('YYYY-MM-DD[T]00:00:00'),
        },
        headers,
      })
        .then(result => {
          const resData = result?.data?.data
          data = resData.length ? res.map(item => {
            const foundPrice = resData.find(f => f.product_id === item.id || f.product_id === item.product_id)
            const range_price = foundPrice?.range_price
            const currency = foundPrice?.catalogs?.[0]?.price_list?.[0]?.currency
            if (range_price) {
              return {
                ...item,
                range_price,
                currency,
              }
            }
            return {
              ...item,
              currency,
            }
          }) : res
          props = obj
        })
        .catch(() => {
          data = res || []
          props = obj || {}
        })
    } else if (['tiktok', 'tiktok_id'].includes(channel)) {
      data = res?.map(item => {
        return {
          ...item,
          catalogs: item.catalogs?.map(catalog => {
            const tempChannelCatalogId = catalog.catalog_id
            const tempMasterCatalogId = catalog.channel_catalog_id
            return {
              ...catalog,
              catalog_id: tempMasterCatalogId,
              channel_catalog_id: tempChannelCatalogId,
            }
          }),
        }
      }) || []
      props = obj || {}
    } else if (['zalora_id'].includes(channel)) {
      const { products: zaloraProductList, ...rest } = res
      data = zaloraProductList?.map((item) => {
        let newPrice = {}
        if (item.catalogs?.length > 1) {
          const prices = item.catalogs.map(catalog => catalog.prices[0].original_price)
          const minPrice = Math.min(...prices)
          const maxPrice = Math.max(...prices)
          item.catalogs = item.catalogs.map(catalog => ({
            ...catalog,
            attributes: {
              size: catalog.variation,
            },
          }))
          newPrice = {
            currency: item.catalogs[0].prices[0].currency,
            min: minPrice,
            max: maxPrice,
          }
        } else {
          newPrice = {
            currency: item.catalogs[0].prices[0].currency,
            min: item.catalogs[0].prices[0].original_price,
            max: item.catalogs[0].prices[0].original_price,
          }
        }
        return {
          ...item,
          price: newPrice,
        }
      }) || []
      props = rest || {}
    } else {
      data = isBlibli
        ? res.map(item => ({
          product_id: item.product_id,
          channel_product_id: item.product_id,
          title: item.product_title,
          status: item.mapping_state,
          product_status: item.state,
          channel_product_status: 'ARCHIVE',
          catalogs: item.catalogs.map(catalog => ({
            catalog_id: catalog.id,
            channel_catalog_id: catalog.id,
            channel_product_id: item.product_id,
            master_product_id: catalog.master_product_id,
            master_catalog_id: catalog.master_catalog_id,
            status: catalog.status,
            title: catalog.title,
            sku: catalog.seller_sku,
            blibli_sku: catalog.blibli_sku,
            factory_sku: null,
            attributes: {},
            attribute_details: null,
            price: null,
            images: catalog.image_path,
            selections: null,
            created_at: null,
            warehouse_list: null,
          })),
          price: {
            currency: item.price.normal.min.currency,
            min: item.price.normal.min.value,
            max: item.price.normal.max.value,
          },
          category: {
            name: item.category.blibli_name,
          },
          variant_count: item.variant_count,
          images: [{
            url_list: [item.image_path],
            thumb_url_list: [item.image_path],
          }],
          import_status: null,
          reason_import_status: null,
        }))
        : res || []
      props = obj || {}
    }
  } catch (err) {
    return Promise.reject(err)
  } finally {
    commit(MutationTypes.SET_PRODUCT_CHANNEL, {
      loading: false,
    })
    if (isExport) return Promise.resolve(data)
    commit(MutationTypes.SET_PRODUCT_CHANNEL, {
      loading: false,
      products: data,
      props,
    })
  }
}

export const GETPRODUCTNOTCOMMITSTATE = async (
  { commit, state },
  { business_id, channel, channelId, params, signal, productId },
) => {
  let data = [],
    props = { all: 0, total_row: 0 }

  try {
    commit(MutationTypes.SET_PRODUCT_CHANNEL, {
      loading: true,
    })

    const headers = {
      'Business-Id': business_id,
    }

    const isDistributor = channel === 'distributor'
    const isBlibli = channel.includes('blibli')

    let url = `/channel/${channel}/product/query/${isDistributor ? 'powerbiz/' : ''}${channelId}`
    if (['shopee', 'shopee_id'].includes(channel)) {
      url = `/channel/shopee/v2/product/query/${channelId}`
    } else if (['toco', 'toco_id'].includes(channel)) {
      url = `/channel/toco/product/query/${channelId}`
    }

    const { data: response } = await apiClient({
      method: 'get',
      url,
      params,
      paramsSerializer: (params) => qs.stringify(params, { encodeValuesOnly: true }),
      headers,
      signal,
    })

    const { data: res, ...obj } = response || {}
    obj.all = obj.active + obj.notActive // ???

    if (isDistributor && res?.length && !isExport) {
      await apiClient({
        method: 'get',
        url: `/channel/distributor/price/query/v2/powerbiz/${channelId || ''}`,
        params: {
          product_id: res.map(f => f.id || f.product_id).join(','),
          effective_date: moment().format('YYYY-MM-DD[T]00:00:00'),
        },
        headers,
      })
        .then(result => {
          const resData = result?.data?.data
          data = resData.length ? res.map(item => {
            const foundPrice = resData.find(f => f.product_id === item.id || f.product_id === item.product_id)
            const range_price = foundPrice?.range_price
            const currency = foundPrice?.catalogs?.[0]?.price_list?.[0]?.currency
            if (range_price) {
              return {
                ...item,
                range_price,
                currency,
              }
            }
            return {
              ...item,
              currency,
            }
          }) : res
          props = obj
        })
        .catch(() => {
          data = res || []
          props = obj || {}
        })
    } else if (['tiktok', 'tiktok_id'].includes(channel)) {
      data = res?.map(item => {
        return {
          ...item,
          catalogs: item.catalogs?.map(catalog => {
            const tempChannelCatalogId = catalog.catalog_id
            const tempMasterCatalogId = catalog.channel_catalog_id
            return {
              ...catalog,
              catalog_id: tempMasterCatalogId,
              channel_catalog_id: tempChannelCatalogId,
            }
          }),
        }
      }) || []
      props = obj || {}
    } else if (['shopee', 'shopee_id'].includes(channel)) {
      const rawList = res?.product_list || []
      const productStatusMap = {
        NORMAL: 'ACTIVE',
        BANNED: 'NOT_ACTIVE',
        DELETED: 'NOT_ACTIVE',
        UNLIST: 'NOT_ACTIVE',
      }
      data = rawList.map((item) => {
        const images = (item.image_urls || []).map((url) => ({
          url_list: [url],
          thumb_url_list: [url],
        }))
        const catalogs = (item.catalogs || []).length > 0
          ? item.catalogs.map((cat) => ({
            catalog_id: cat.catalog_id,
            channel_catalog_id: cat.channel_catalog_id,
            channel_product_id: item.channel_product_id,
            master_product_id: cat.master_product_id,
            master_catalog_id: cat.master_catalog_id,
            status: cat.status || item.sync_state || 'UNCONFIRMED',
            title: cat.title || item.title,
            sku: cat.sku || item.matched_model_sku || item.product_sku || '',
            attributes: cat.attributes || {},
            price: cat.price || (item.price ? [{ original_price: item.price.min, current_price: item.price.min, currency: item.price.currency }] : []),
            images: (cat.images || []).length > 0 ? cat.images : images,
            warehouses: cat.warehouses || [],
          }))
          : [{
            catalog_id: null,
            channel_catalog_id: item.id,
            channel_product_id: item.channel_product_id,
            master_product_id: null,
            master_catalog_id: null,
            status: item.sync_state || 'UNCONFIRMED',
            title: item.title,
            sku: item.matched_model_sku || item.product_sku || '',
            attributes: {},
            price: item.price ? [{ original_price: item.price.min, current_price: item.price.min, currency: item.price.currency }] : [],
            images,
            warehouses: [],
          }]
        const syncState = item.sync_state || 'UNCONFIRMED'

        return {
          product_id: item.id,
          channel_product_id: item.channel_product_id,
          title: item.title,
          variant_count: item.variant_count,
          price: item.price,
          category_name: item.category?.name || null,
          category: item.category,
          images,
          catalogs,
          status: syncState,
          product_status: productStatusMap[item.product_status] || item.product_status,
          channel_product_status: item.product_status,
          import_status: null,
          reason_import_status: null,
        }
      })
      props = res || {}
    } else if (['toco', 'toco_id'].includes(channel)) {
      const rawList = res?.product_list || []
      const productStatusMap = {
        NORMAL: 'ACTIVE',
        BANNED: 'NOT_ACTIVE',
        DELETED: 'NOT_ACTIVE',
        UNLIST: 'NOT_ACTIVE',
      }
      data = rawList.map((item) => {
        const images = (item.image_urls || []).map((url) => ({
          url_list: [url],
          thumb_url_list: [url],
        }))
        const catalogs = (item.catalogs || []).length > 0
          ? item.catalogs.map((cat) => ({
            catalog_id: cat.catalog_id,
            channel_catalog_id: cat.channel_catalog_id,
            channel_product_id: item.channel_product_id,
            master_product_id: cat.master_product_id,
            master_catalog_id: cat.master_catalog_id,
            status: cat.status || item.sync_state || 'UNCONFIRMED',
            title: cat.title || item.title,
            sku: cat.sku || item.matched_model_sku || item.product_sku || '',
            attributes: cat.attributes || {},
            price: cat.price || (item.price ? [{ original_price: item.price.min, current_price: item.price.min, currency: item.price.currency }] : []),
            images: (cat.images || []).length > 0 ? cat.images : images,
            warehouses: cat.warehouses || [],
          }))
          : [{
            catalog_id: null,
            channel_catalog_id: item.id,
            channel_product_id: item.channel_product_id,
            master_product_id: null,
            master_catalog_id: null,
            status: item.sync_state || 'UNCONFIRMED',
            title: item.title,
            sku: item.matched_model_sku || item.product_sku || '',
            attributes: {},
            price: item.price ? [{ original_price: item.price.min, current_price: item.price.min, currency: item.price.currency }] : [],
            images,
            warehouses: [],
          }]
        const syncState = item.sync_state || 'UNCONFIRMED'

        return {
          product_id: item.id,
          channel_product_id: item.channel_product_id,
          title: item.title,
          variant_count: item.variant_count,
          price: item.price,
          category_name: item.category?.name || null,
          category: item.category,
          images,
          catalogs,
          status: syncState,
          product_status: productStatusMap[item.product_status] || item.product_status,
          channel_product_status: item.product_status,
          import_status: null,
          reason_import_status: null,
        }
      })
      props = res || {}
    } else if (['zalora_id'].includes(channel)) {
      const { products: zaloraProductList, ...rest } = res
      data = zaloraProductList?.map((item) => {
        let newPrice = {}
        if (item.catalogs?.length > 1) {
          const prices = item.catalogs.map(catalog => catalog.prices[0].original_price)
          const minPrice = Math.min(...prices)
          const maxPrice = Math.max(...prices)
          item.catalogs = item.catalogs.map(catalog => ({
            ...catalog,
            attributes: {
              size: catalog.variation,
            },
          }))
          newPrice = {
            currency: item.catalogs[0].prices[0].currency,
            min: minPrice,
            max: maxPrice,
          }
        } else {
          newPrice = {
            currency: item.catalogs[0].prices[0].currency,
            min: item.catalogs[0].prices[0].original_price,
            max: item.catalogs[0].prices[0].original_price,
          }
        }
        return {
          ...item,
          price: newPrice,
        }
      }) || []
      props = rest || {}
    } else {
      data = isBlibli
        ? res.map(item => ({
          product_id: item.product_id,
          channel_product_id: item.product_id,
          title: item.product_title,
          status: item.mapping_state,
          product_status: item.state,
          channel_product_status: 'ARCHIVE',
          catalogs: item.catalogs.map(catalog => ({
            ...catalog,
            catalog_id: catalog.id,
            channel_catalog_id: catalog.id,
            channel_product_id: item.product_id,
            master_product_id: catalog.master_product_id,
            master_catalog_id: catalog.master_catalog_id,
            status: catalog.status,
            title: catalog.title,
            sku: catalog.seller_sku,
            factory_sku: null,
            attributes: {},
            attribute_details: null,
            price: null,
            images: catalog.image_path,
            selections: null,
            created_at: null,
            warehouse_list: null,
          })),
          price: {
            currency: item.price.normal.min.currency,
            min: item.price.normal.min.value,
            max: item.price.normal.max.value,
          },
          category: {
            name: item.category.blibli_name,
          },
          variant_count: item.variant_count,
          images: [{
            url_list: [item.image_path],
            thumb_url_list: [item.image_path],
          }],
          import_status: null,
          reason_import_status: null,
        }))
        : res || []
      props = obj || {}
    }
    return Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  } finally {

    const findProductOnResData = data.find(obj => obj.product_id === productId)
    const findProductIndexOnStateData = state.products.findIndex(obj => obj.product_id === productId)
    const newData = state.products
    newData[findProductIndexOnStateData] = findProductOnResData
    commit(MutationTypes.SET_PRODUCT_CHANNEL, {
      loading: false,
      products: newData,
    })
  }
}
